var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{mac:_vm.is_mac},staticStyle:{"min-width":"1007px"},attrs:{"id":"app"}},[_c('router-view'),_c('UserArgePopup'),_c('PrivacyArgePopup')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }